import {getTplOptions} from './helper';
import {btbIndustry, normalIndustry} from './constants';
import {textFixed, imageFixed} from './format';

const designSizeControlParams = {
    indestryBaseSizeMap: {
        ...btbIndustry.reduce((acc, item) => {
            acc[item] = '1:1';
            return acc;
        }, {}),
        ...normalIndustry.reduce((acc, item) => {
            acc[item] = '16:9';
            return acc;
        }, {})
    },
    sizeControlOptions: function (e) {
        return getTplOptions(e);
    }
};

export const defaultFormConfig = [{
    name: 'templateGroup',
    label: '选择模板',
    placeholder: '',
    visible: true,
    type: 'collapse',
    params: {
        showConfirmDialog: true,
        mainComponentName: 'template-main-tab',
        templateTag: [],
        buttonTypes: ['switch'],
        colorOptions: [
            {
                value: '',
                label: '全部色系'
            }, {
                value: '红色',
                label: '红色'
            }, {
                value: '黄色',
                label: '黄色'
            }, {
                value: '橙色',
                label: '橙色'
            }, {
                value: '绿色',
                label: '绿色'
            }, {
                value: '蓝色',
                label: '蓝色'
            }
        ],
        industryOptions: [
            {
                value: '',
                label: '全部行业'
            },
            {
                value: '5',
                label: '教育培训'
            },
            {
                value: '19',
                label: '文娱传媒'
            },
            {
                value: '10',
                label: '金融服务'
            },
            {
                value: '8',
                label: '生活服务'
            },
            {
                value: '11',
                label: '房产家居'
            },
            {
                value: '4',
                label: '整形美容'
            },
            {
                value: '7',
                label: '商务服务'
            },
            {
                value: '17',
                label: '旅游服务'
            },
            {
                value: '9',
                label: '商品交易'
            },
            {
                value: '16',
                label: '游戏'
            },
            {
                value: '15',
                label: '软件'
            },
            {
                value: '13',
                label: '交通出行'
            },
            {
                value: '30',
                label: '网络服务'
            },
            {
                value: '14',
                label: '机械设备'
            },
            {
                value: '3',
                label: '医疗服务'
            },
            {
                value: '31',
                label: '农林牧渔'
            },
            {
                value: '29',
                label: '通信'
            },
            {
                value: '20',
                label: '化工及能源'
            },
            {
                value: '28',
                label: '电子电工'
            },
            {
                value: '34',
                label: '直营电商'
            },
            {
                value: '25',
                label: '食品饮料'
            },
            {
                value: '22',
                label: '保健品/药品'
            }
        ],
        ratioOptions: function (e) {
            return getTplOptions(e);
        },
        ...designSizeControlParams,
        chooseMax: 1
    },
    rules: []
}, {
    name: 'textBatchGroup',
    label: '设置文字图层',
    placeholder: '',
    visible: true,
    type: 'collapse',
    params: {
        textFixed,
        titleTip: true,
        titleTipText: '请输入文案，多条文案可折行输入',
        placeholder: '请输入文案，多条文案可折行输入'
    },
    rules: []
},
{
    name: 'imageBatchGroup',
    label: '设置图片图层',
    placeholder: '',
    visible: true,
    type: 'collapse',
    canCutout: true,
    params: {
        imageFixed
    },
    rules: []
}
];